export class NoteTypeCategory {
	public id: number;
	public name: string;

	constructor(noteTypeCategory?: Subset<NoteTypeCategory>) {
		Object.assign(this, noteTypeCategory);
	}
}
